import styled from "styled-components"

import { SPACING } from "ggx-componentlibrary/design/spacing/spacing.constants"
import { COLOR } from "ggx-componentlibrary/design/color/color.constants"
import CouponSVG from 'ggx-global/navigation/v2/assets/coupon.svg'
import CouponCheckSVG from 'ggx-global/navigation/v2/assets/coupon-check.svg'
import RightIconSVG from 'ggx-src/van-booking/order/sidebar/order-form/summary/payment-method/assets/right_icon.svg'
import { BodyBold } from 'ggx-componentlibrary/design/typography/typography.styles'

const CouponModelTrigger = styled.div`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
`

const RightIcon = styled(RightIconSVG)`
`

const CouponIcon = styled(CouponSVG)`
  flex: 0 0 24px;
`
const CouponCheckIcon = styled(CouponCheckSVG)`
  flex: 0 0 24px;
`

const StyledBadge = styled.div`
  display: inline-block;
  padding: 0px 6px;
  background: ${COLOR.YELLOW_MEDIUM};
  color: ${COLOR.BLACK};
  border-radius: 9999px;
  font-size: 10px;
  font-weight: 700;
  line-height: 16px;
`


const StyledCouponSection = styled.div`
  border-top: 1px solid ${COLOR.GREY_LIGHT};
  padding-top: ${SPACING.M};
  padding-bottom: ${SPACING.M};
  display: flex;
  gap: 12px;
  align-items: center;
  > ${CouponIcon} {
    opacity: ${props => props.$isActive ? '123' : '0.6'};
    path { stroke: ${props => props.$isActive ? COLOR.BLUE_MEDIUM : COLOR.DARK}; }
  }
  ${CouponModelTrigger} > ${BodyBold} {
    color: ${props => props.$isActive ? COLOR.BLUE_MEDIUM : COLOR.DARK};
  }
  ${CouponModelTrigger} > ${RightIcon} {
    path { stroke: ${props => props.$isActive ? COLOR.BLUE_MEDIUM : COLOR.DARK}; }
  }
  > ${StyledBadge} {
    display: ${props => props.$isActive ? 'inline-block' : 'none'}
  }
`

export { StyledCouponSection, CouponModelTrigger, RightIcon, CouponIcon, CouponCheckIcon, StyledBadge }
